import { render } from "./TransferView.vue?vue&type=template&id=387242ec&scoped=true"
import script from "./TransferView.vue?vue&type=script&lang=js"
export * from "./TransferView.vue?vue&type=script&lang=js"

import "./TransferView.vue?vue&type=style&index=0&id=387242ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387242ec"]])

export default __exports__